import * as React from 'react';
import { Toast } from 'antd-mobile';
import intl from 'react-intl-universal';

import * as api from '@services/api';

export class ComponentExt<P = {}, S = {}> extends React.Component<P, S> {
    readonly $api = api;
    readonly $toast = Toast;
}

export class StoreExt {
    readonly $api = api;
    readonly $toast = Toast;
    readonly $intl = intl;
}
